

















import { Component, Vue } from "vue-property-decorator";
import CButton from "@/basics/buttons/CButton.vue";
import { resetAppUser } from "@/graphql/mutation/resetAppUser";
import NoteBox from "@/basics/boxes/NoteBox.vue";
import NoData from "@/basics/boxes/NoData.vue";
import PrintTable from "@/basics/table/PrintTable.vue";
import {
  AppUserData,
  ONE_APP_USER,
  OneAppUserVariables
} from "@/graphql/query/appUser/one";

@Component({
  components: {
    CButton,
    NoteBox,
    NoData,
    PrintTable
  },
  apollo: {
    appUser: {
      query: ONE_APP_USER,
      variables(): OneAppUserVariables {
        return { id: this.$apollo.vm.$route.params.appUserId };
      }
    }
  }
})
export default class AppAccountInvite extends Vue {
  appUser: AppUserData | null = null;

  get appUserId(): string {
    return this.$route.params.appUserId;
  }

  async generate() {
    const tab = window.open("", "_blank")!;
    const id = this.appUserId;
    const { data } = await resetAppUser(this.$apollo, id);
    const password = data!.resetAppUser;
    const { start, end, name } = this.appUser!;
    const { href } = this.$router.resolve({
      name: "print-app-account",
      query: {
        start: start.toString(),
        end: end.toString(),
        name,
        id,
        password
      }
    });
    tab!.location.href = href;
  }
}
